module.exports = __webpack_public_path__ + "static/media/export.bcb0aefa.svg";